export default __webpack_public_path__ + "static/media/monkey18.d8d09af0.jpeg";